export class AutomationStepsCountsModel {
    DueEmails: number;
    SentEmails: number;
    DueSMSs: number;
    SentSMSs: number

  constructor(init: any) {
      this.DueEmails = init.DueEmails;
      this.SentEmails = init.SentEmails;
      this.DueSMSs = init.DueSMSs;
      this.SentSMSs = init.SentSMSs; 
  }  
}